import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgExitLeftGhostLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M9 21a1 1 0 0 0 1 1c3.007 0 5.597-.753 7.422-2.578S20 15.007 20 12s-.753-5.597-2.578-7.422S13.007 2 10 2a1 1 0 0 0 0 2c2.7 0 4.69.675 6.008 1.992S18 9.3 18 12s-.675 4.69-1.992 6.008S12.7 20 10 20a1 1 0 0 0-1 1'
      clipRule='evenodd'
      opacity={0.2}
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M9.322 7.894a1 1 0 0 1 .617.924V11h4.304a1 1 0 1 1 0 2H9.939v2.182a1 1 0 0 1-1.707.707L5.05 12.707a1 1 0 0 1 0-1.414L8.232 8.11a1 1 0 0 1 1.09-.217'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgExitLeftGhostLine)
export default ForwardRef
